import customFetch from '../../utils/customFetch';

export const getNewSpecialist = (curPage = 1, numberItemPerPage = 20) => {
  return customFetch(
    `/Report/GetStatisticsSpecialistStatus?curPage=${curPage}&numItemOfPage=${numberItemPerPage}`,
    {
      method: 'GET',
    },
  );
};

export const getNewClient = (curPage = 1, numberItemPerPage = 20) => {
  return customFetch(
    `/Report/GetStatisticsNewClient?curPage=${curPage}&numItemOfPage=${numberItemPerPage}`,
    {
      method: 'GET',
    },
  );
};

export const getNewClinic = (curPage = 1, numberItemPerPage = 20) => {
    return customFetch(
      `/Report/GetStatisticsNewClinic?curPage=${curPage}&numItemOfPage=${numberItemPerPage}`,
      {
        method: 'GET',
      },
    );
  };
